import { Component, OnInit } from '@angular/core';
import { BrokerAdminTableConfig } from "./broker-admin.table-config";
import { BrokerAdminService } from '@app/services';
import { ApiResponse } from '@app/interfaces';
@Component({
  selector: 'app-broker-admin-list',
  templateUrl: './broker-admin-list.component.html',
  styleUrls: ['./broker-admin-list.component.scss']
})
export class BrokerAdminListComponent implements OnInit {
  addPanel: boolean = false;
  config: any;
  isLoading: boolean = false;
  dataSource: any = []
  editSelected: any;

  constructor(
    private brokerAdminService: BrokerAdminService
  ) { }

  ngOnInit(): void {
    this.config = BrokerAdminTableConfig.configure();
    this.getList();
  }

  getList() {
    this.isLoading = true;
    this.brokerAdminService.list().subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.dataSource = res.data.map((o: any) => {
          o.name = `${o.user?.firstName ?? ''} ${o.user?.lastName ?? ''}`
          return o
        })
      }
    })
  }

  action(e: any) {
    this.editSelected = null;
    if (e.button.eventName == "edit") {
      this.editSelected = e.data
      this.addPanel = true;
    }
    if (e.button.eventName == "add") {
      this.addPanel = true;
    }
  }

  onPopupclose() {
    this.addPanel = false
    this.editSelected = null;
    this.getList();
  }

}
